<div class="full-page" [style.background-image]="'url(' + ('login-registration/login-background.jpg' | contentAssetImage) + ')'">
  <div class="container">
    <img class="logo" [src]="'logos/login-logo.svg' | contentAssetImage" />

    <div class="bg-white maintenance-container">
      <img class="container-logo" [src]="'logos/logo.svg' | contentAssetImage" />
      <h5 class="title text-primary">{{ 'maintenance.page.title' | translate }}</h5>
      <p class="description font-size-14 text-center mb-0 text-primary">{{ 'maintenance.page.details' | translate }}</p>
    </div>
  </div>
</div>
